// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__vknAf","rootSmall":"AddTileButton_rootSmall__3X-hV"};